import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import authService from './AuthorizeService';
import { ApplicationPaths } from './ApiAuthorizationConstants';
import { Dropdown, Icon } from 'semantic-ui-react';

interface State {
    isAuthenticated: boolean;
    name: string;
    userName: string | null;
}

export class LoginMenu extends Component<{}, State> {
    private _subscription: number = 0;

    constructor(props: {}) {
        super(props);
        this.state = { isAuthenticated: false, name: '', userName: null };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    private async populateState() {
        const [isAuthenticated, user] = await Promise.all([
            authService.isAuthenticated(),
            authService.getUser(),
        ]);
        this.setState({
            isAuthenticated,
            name: user ? `${user['given_name'] || ''} ${user['family_name'] || ''}`.trim() : '',
            userName: (user?.['name'] as string) ?? null,
        });
    }

    private isEmptyOrSpaces(str: string | null): boolean {
        return str === null || str.match(/^ *$/) !== null;
    }

    render() {
        const { isAuthenticated, userName, name } = this.state;
        if (!isAuthenticated) {
            return this.anonymousView();
        }
        const logoutPath = { pathname: ApplicationPaths.LogOut, state: { local: true } };
        const displayName = this.isEmptyOrSpaces(name) ? userName : name;
        return this.authenticatedView(displayName, ApplicationPaths.Profile, logoutPath);
    }

    private authenticatedView(
        displayName: string | null,
        profilePath: string,
        logoutPath: { pathname: string; state: { local: boolean } }
    ) {
        return (
            <Dropdown item trigger={<Icon name="user outline" />}>
                <Dropdown.Menu>
                    <Dropdown.Item>{displayName}</Dropdown.Item>
                    <Dropdown.Item as={NavLink} to={profilePath}>
                        Profile
                    </Dropdown.Item>
                    <Dropdown.Item as={NavLink} to={logoutPath}>
                        Log out
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    private anonymousView() {
        return <div></div>;
    }
}

